/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Menu, { Item as MenuItem } from "rc-menu";
import "./dropdown.css";
import Dropdown from "rc-dropdown";

import FormController from "../../../../FormController/FormController";
import {
  getOpponents,
  getGamesByOpponent,
} from "../../../../../features/cms/cmsSlice";
import FormTitle from "../../../../FormTitle/FormTitle";
import styles from "./GamesByOpponent.module.scss";
import { GameItemList } from "../../../components/GameItemList/GameItemList";

const GamesByOpponent = () => {
  const history = useHistory();
  const [opponent, setOpponent] = useState(history.location.state?.data);
  const { type } = useSelector((state) => state?.singleGroup);
  const opponents = useSelector(getOpponents);
  const games = useSelector(getGamesByOpponent(opponent));
  const [selectedOpponent, setSelectedOpponent] = useState(
    opponents.find((o) => o.alias === history.location.state?.data)?.name
  );

  function onSelect({ key }) {
    setOpponent(key);
    setSelectedOpponent(opponents.find((o) => o.alias === key).name);
  }

  function onVisibleChange(visible) {
    console.log(visible);
  }

  const menu = (
    <Menu onSelect={onSelect}>
      {opponents.map((opponent) => (
        <MenuItem disabled={!opponent.active} key={opponent.alias}>
          {opponent.name}
        </MenuItem>
      ))}
    </Menu>
  );

  useEffect(() => {
    if (!type) history.push("/");
  }, [games, history, type]);

  return (
    <div className={styles.body}>
      <FormTitle title="by Opponent" />
      <Dropdown
        trigger={["click"]}
        overlay={menu}
        animation="slide-up"
        onVisibleChange={onVisibleChange}
      >
        <button className="rc-dropdown-btn">
          {selectedOpponent}
          <img
            className="btn-arrow"
            src={require("../../../../../assets/images/icons/arrow-icon-2.svg")}
            alt=""
          />
        </button>
      </Dropdown>
      <div className={styles.wrapper}>{<GameItemList games={games} />}</div>
      <FormController
        backTo="/ticket-single-group/by-opponent"
        startOver="/"
        showBack
        showStartOver
      />
    </div>
  );
};

export default GamesByOpponent;
